var Account, AccountInfo, AccountState, ActionFactories, Breadcrumbs, HeadingBar, LoginPage, LoginPanel, Page, m;

m = require('mithril');

ActionFactories = require('../../state/ActionFactories');

AccountState = require('../../state/Account');

Account = require('../components/Account');

Page = require('../components/Page');

HeadingBar = require('../components/HeadingBar');

Breadcrumbs = require('../components/Breadcrumbs');

AccountInfo = require('../components/AccountInfo');

LoginPanel = require('../components/LoginPanel');

LoginPage = {
  controller: function(args) {
    var ctrl;
    ctrl = this;
    ctrl.loadAccount = function(acc) {
      return args.loadAccount(acc).then(function(acc) {
        return m.route('/home');
      });
    };
    return ctrl;
  },
  view: function(ctrl, args) {
    var account;
    account = args.account();
    return m(Page, {
      account: account,
      content: [
        m(HeadingBar, {
          content: m(Breadcrumbs, {
            items: [
              {
                icon: 'home',
                title: 'Home',
                onclick: function() {
                  return m.route('/home');
                }
              }, {
                icon: 'profile',
                content: 'Account'
              }
            ]
          })
        }), m(AccountInfo, {
          account: account,
          loadAccount: ctrl.loadAccount
        }), m(LoginPanel, {
          loadAccount: ctrl.loadAccount
        })
      ]
    });
  }
};

module.exports = function(store) {
  return m(LoginPage, {
    account: function() {
      return store.getState().account;
    },
    loadAccount: function(name) {
      return AccountState.loadAccount(store, name);
    }
  });
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL2FwcC9zcmMvdWkvcGFnZXMvTG9naW5QYWdlLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9hcHAvc3JjL3VpL3BhZ2VzL0xvZ2luUGFnZS5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxDQUFBLEdBQUksT0FBQSxDQUFRLFNBQVI7O0FBRUosZUFBQSxHQUFrQixPQUFBLENBQVEsNkJBQVI7O0FBQ2xCLFlBQUEsR0FBZ0IsT0FBQSxDQUFRLHFCQUFSOztBQUVoQixPQUFBLEdBQVksT0FBQSxDQUFRLHVCQUFSOztBQUNaLElBQUEsR0FBVSxPQUFBLENBQVEsb0JBQVI7O0FBQ1YsVUFBQSxHQUFlLE9BQUEsQ0FBUSwwQkFBUjs7QUFDZixXQUFBLEdBQWUsT0FBQSxDQUFRLDJCQUFSOztBQUNmLFdBQUEsR0FBZSxPQUFBLENBQVEsMkJBQVI7O0FBQ2YsVUFBQSxHQUFjLE9BQUEsQ0FBUSwwQkFBUjs7QUFFZCxTQUFBLEdBQVk7RUFDWCxVQUFBLEVBQVksU0FBQyxJQUFEO0FBQ1gsUUFBQTtJQUFBLElBQUEsR0FBTztJQUNQLElBQUksQ0FBQyxXQUFMLEdBQW1CLFNBQUMsR0FBRDthQUNsQixJQUFJLENBQUMsV0FBTCxDQUFpQixHQUFqQixDQUNDLENBQUMsSUFERixDQUNPLFNBQUMsR0FBRDtlQUFTLENBQUMsQ0FBQyxLQUFGLENBQVEsT0FBUjtNQUFULENBRFA7SUFEa0I7V0FHbkI7RUFMVyxDQUREO0VBUVgsSUFBQSxFQUFNLFNBQUMsSUFBRCxFQUFPLElBQVA7QUFDTCxRQUFBO0lBQUEsT0FBQSxHQUFVLElBQUksQ0FBQyxPQUFMLENBQUE7V0FFVixDQUFBLENBQUUsSUFBRixFQUFRO01BQ1AsT0FBQSxFQUFTLE9BREY7TUFFUCxPQUFBLEVBQVM7UUFDUixDQUFBLENBQUUsVUFBRixFQUFjO1VBQ2IsT0FBQSxFQUFTLENBQUEsQ0FBRSxXQUFGLEVBQWU7WUFBQyxLQUFBLEVBQU87Y0FDL0I7Z0JBQUMsSUFBQSxFQUFNLE1BQVA7Z0JBQWUsS0FBQSxFQUFPLE1BQXRCO2dCQUE4QixPQUFBLEVBQVMsU0FBQTt5QkFBTSxDQUFDLENBQUMsS0FBRixDQUFRLE9BQVI7Z0JBQU4sQ0FBdkM7ZUFEK0IsRUFFL0I7Z0JBQUMsSUFBQSxFQUFNLFNBQVA7Z0JBQWtCLE9BQUEsRUFBUyxTQUEzQjtlQUYrQjthQUFSO1dBQWYsQ0FESTtTQUFkLENBRFEsRUFPUixDQUFBLENBQUUsV0FBRixFQUFlO1VBQUMsU0FBQSxPQUFEO1VBQVUsV0FBQSxFQUFhLElBQUksQ0FBQyxXQUE1QjtTQUFmLENBUFEsRUFRUixDQUFBLENBQUUsVUFBRixFQUFjO1VBQUMsV0FBQSxFQUFhLElBQUksQ0FBQyxXQUFuQjtTQUFkLENBUlE7T0FGRjtLQUFSO0VBSEssQ0FSSzs7O0FBMEJaLE1BQU0sQ0FBQyxPQUFQLEdBQWlCLFNBQUMsS0FBRDtTQUNoQixDQUFBLENBQUUsU0FBRixFQUFhO0lBQ1osT0FBQSxFQUFTLFNBQUE7YUFBTSxLQUFLLENBQUMsUUFBTixDQUFBLENBQWdCLENBQUM7SUFBdkIsQ0FERztJQUVaLFdBQUEsRUFBYSxTQUFDLElBQUQ7YUFBVSxZQUFZLENBQUMsV0FBYixDQUF5QixLQUF6QixFQUFnQyxJQUFoQztJQUFWLENBRkQ7R0FBYjtBQURnQiJ9
